class AlgoliaHitCarousel extends HTMLElement {
  constructor() {
    super();
    this.render = this.render.bind(this);
  }

  /**
   * Renders and returns content.
   * @param {string} handle - The shopify product handle 
   * @param {Object} colorOptions - The object with key pair values of color options available for this hit.
   * @param {string} cardColor - used to determine which image should be active on the first render
   * @param {function} mouseOverCB - Callback function triggered on thumbnail mouseover
   * @param {function} mouseOutCB - Callback function triggered on thumbnail mouseout
   * @param {function} clickCB - Callback function triggered on thumbnail click 
   * @param {strine} mediaCameraShy - fallback image url to use if image doesn't load
   * @returns {string} The rendered content HTML.
   */
  render(handle, colorOptions = {}, cardColor, mouseOverCB, mouseOutCB, clickCB, mediaCameraShy) {
    const carouselEl = this.cloneNode(true);
    const sliderWrapper = carouselEl.querySelector('ul');
    sliderWrapper.id = `Slider-${handle}`;
    
    Array.from(Object.keys(colorOptions)).forEach((option, ind) => {
      const li = document.createElement('li');
      li.classList.add('slider__slide', 'grid__item', 'algolia-hit-slider');
      li.id = `Slide-${handle}-${option}`
      let optionFrame;
      if (colorOptions[option].hexcode) {
        const colorSwatch = document.createElement('div');
        colorSwatch.classList.add('algolia-carousel__color-swatch');
        colorSwatch.style.backgroundColor = colorOptions[option].hexcode.startsWith('#') ?
          colorOptions[option].hexcode :
          `#${colorOptions[option].hexcode}`;
        colorSwatch.setAttribute('src', colorOptions[option].thumbnailFrontUrl);
        colorSwatch.setAttribute('alt', option);
        colorSwatch.setAttribute('aria-label', option);
        optionFrame = colorSwatch;
        li.appendChild(colorSwatch);
      } else {
        const img = document.createElement('img');
        img.alt = option;
        img.src = colorOptions[option].thumbnailFrontUrl;
        img.setAttribute('onerror', `this.onerror=null;this.src='${mediaCameraShy}'`);
        optionFrame = img;
        li.appendChild(img);
      } 
      if (mouseOverCB) optionFrame.addEventListener('mouseenter', mouseOverCB);
      if (mouseOutCB) optionFrame.addEventListener('mouseout', mouseOutCB);
      if (clickCB) optionFrame.addEventListener('click', clickCB);
      
      if (cardColor === option) {
        optionFrame.classList.add('active');
        // the first color in the colorOptions is not always the same as the card color
        // we're force inserting the matching color to the start of
        sliderWrapper.insertBefore(li, sliderWrapper.firstChild);
      } else {
        sliderWrapper.appendChild(li);
      }
    });
    return carouselEl;
  }  
}

customElements.define("algolia-hit-carousel", AlgoliaHitCarousel);
